var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "-mt-12 sm-md:mt-0"
  }, [_c('div', {
    staticClass: "section--container"
  }, [_c('div', {
    staticClass: "container max-w-3xl section--content flex flex-col items-center text-center"
  }, [_vm._m(0), _vm._v(" "), _c('h1', {
    staticClass: "mt-4 mb-4"
  }, [_vm._v("Connect your bank to continue")]), _vm._v(" "), _c('p', {
    staticClass: "leading-6 mb-8"
  }, [_vm._v("\n\t\t\t\tBefore you can review and accept your updated agreements, we need you to link your\n\t\t\t\tprimary checking account.\n\t\t\t")]), _vm._v(" "), _vm.plaidError ? _c('p', {
    staticClass: "text-red-600 mb-6 leading-6"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.plaidError) + "\n\t\t\t")]) : _vm._e(), _vm._v(" "), _vm.canLinkOnWeb ? _c('button', {
    staticClass: "button--mint button--filled sm:w-full",
    class: {
      disabled: _vm.plaidProcessing
    },
    attrs: {
      "disabled": _vm.plaidProcessing
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('connect-plaid');
      }
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.plaidProcessing ? 'Hold tight...' : 'Link my bank') + "\n\t\t\t")]) : [_vm.fromApp ? _c('button', {
    staticClass: "button--mint button--filled sm:w-full",
    on: {
      "click": function ($event) {
        return _vm.$emit('dismiss');
      }
    }
  }, [_vm._v("\n\t\t\t\t\tReturn to the Extra app\n\t\t\t\t")]) : _c('nuxt-link', {
    staticClass: "button--mint button--filled sm:w-full",
    attrs: {
      "to": "/download"
    }
  }, [_vm._v("\n\t\t\t\t\tGet the Extra app\n\t\t\t\t")])], _vm._v(" "), _vm.canLinkOnWeb && _vm.fromApp ? _c('button', {
    staticClass: "mt-4 text-sm text-gray-500 underline",
    on: {
      "click": function ($event) {
        return _vm.$emit('dismiss');
      }
    }
  }, [_vm._v("\n\t\t\t\tReturn to the Extra app instead\n\t\t\t")]) : _vm._e()], 2)])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mb-8"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/lock-green.svg"),
      "alt": ""
    }
  })]);
}];
export { render, staticRenderFns };